export default {
	init: function(){
		var allPanels = $('.accordion .accordion__item');

		allPanels.find('.accordion__copy').hide();

		// if(!$('.form__fieldset').length)
		// 	$('.accordion .accordion__item:first-child').addClass('active').find('.accordion__copy').slideDown();

		$(document).on('click', '.accordion .accordion__title', function(e) {
			e.preventDefault();

			var $this = $(this)
			  , $target = $this.next();

			if($target.closest('.accordion__item').hasClass('active')) {
				$target.closest('.accordion__item').removeClass('active');
				$target.slideUp();
			} else {
				allPanels.removeClass('active');
				allPanels.find('.accordion__copy').slideUp();
				$target.closest('.accordion__item').addClass('active');
				$target.slideDown();
			}

			return false;
		});

		if(window.location.hash.length){
			$(window.location.hash).find('.accordion__title').click();
		}
	}
}